<template>
    <div>
        <b-row>
            <b-col cols="12" class="mb-2 mt-5">
                <label class="mb-2 h5 text-uppercase">
                    Documentación del deportista
                </label>
                <DocumentosSubidosComponent :url="url_dni" :text="text_dnis" @documentosSubidos="vdropzone_success_handler"/>
            </b-col>
            <b-col cols="12">
                <DocumentosSubidosComponent :url="url_foto_perfil" :text="text_foto_perfil" @documentosSubidos="vdropzone_success_handler_foto_perfil"/>
            </b-col>
            <b-col cols="12">
                <div class="text-right mt-3">
                    <button type="button" @click="volver" name="button" :class="!esMovil ? 'button effect-button large-button mr-2' : 'button effect-button mr-2'" id="volver-paso-1" :disabled="!paso_activo">
                        <span>{{ $t('formularios.atras') }}</span>
                    </button>
                    <button @click="continuar()" type="submit" name="button" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" id="terminar-paso-2" data-cy="terminar-paso-doc" :disabled="!paso_activo">
                        <span>{{ $t('formularios.continuar') }}</span>
                    </button>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import { list } from 'postcss';
    import DocumentosSubidosComponent from './DocumentosSubidosComponent.vue';

    export default {
        props: {
            base: {
                type: Object,
                required: true
            },
            esMovil: {
                type: Boolean,
                default: false
            },
            paso_activo: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                text_dnis: `
                Si es de nueva inscripción, la información que deben adjuntar los padres son:
                <ul>
                    <li><b>DNI/NIE/Pasaporte (Ambas caras) Jugador</b></li>
                    <li>
                        <b>DNI/NIE/Pasaporte (Ambas caras) de los
                            responsables</b>
                    </li>
                </ul>
            `,
                text_foto_perfil: 'Foto del deportista para el perfil:',
                documentos_id: [],
                url_dni: null,
                url_foto_perfil: null,
                localData: { ...this.base }
            }
        },
        methods: {
            volver() {
                this.$emit('volver');
            },
            continuar() {
                if (this.documentos_id.length > 0 || this.localData.foto_url) {
                    this.guardarDatosComprador();
                }
                this.$emit('terminado', this.localData);
            },
            guardarDatosComprador() {
                let params = {
                    base: this.localData,
                    documentos_id: this.documentos_id,
                    foto_url: this.localData.foto_url || null,
                    lista_id: this.$route.params.lista_id,
                    session_id: this.localData.categoria_base.session_id,
                    filters: {
                        tid: this.configuracion.hash_teatro
                    }
                }

                this.$store.dispatch(this.config.getVuexAlias('back.bases.guardar-documentos'), params);
            },
            vdropzone_success_handler(response) {
                this.documentos_id.push(response.documento_id);
                this.localData['documentos_id'] = this.documentos_id;
            },
            vdropzone_success_handler_foto_perfil(response) {
                this.localData.foto_url = response.url;
            },
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        created() {
            this.url_dni = this.config.API_BASE + "/f/upload/documento" + "?tipo=bases&id=" + this.localData["dni"];
            this.url_foto_perfil = this.config.API_BASE + "/f/guardar-foto-deportista";
        },
        components: {
            DocumentosSubidosComponent
        }
    }
</script>
